import { format } from 'date-fns';
import { de } from 'date-fns/locale';

/** de-DE-Datumsformat TT.MM.JJJJ (erp-design-guideline.md §10). */
export function formatDate(iso: string): string {
  return format(new Date(iso), 'dd.MM.yyyy', { locale: de });
}

/** Initialen aus Name oder E-Mail (Avatar-Kürzel, „Zeichen"-Vorbefüllung). */
export function initials(value: string): string {
  const parts = value.split(/[\s@.]+/).filter(Boolean);
  return (parts[0]?.[0] ?? '?').concat(parts[1]?.[0] ?? '').toUpperCase();
}

/** de-DE Datum + Zeit TT.MM.JJJJ HH:mm. */
export function formatDateTime(iso: string): string {
  return format(new Date(iso), 'dd.MM.yyyy HH:mm', { locale: de });
}

/** Nur die Uhrzeit HH:mm — für Listen, in denen der Tag schon feststeht. */
export function formatTime(iso: string): string {
  return format(new Date(iso), 'HH:mm', { locale: de });
}

/** ISO-Datum → Wert für `<input type="date">` (JJJJ-MM-TT). */
export function isoToDateInput(iso: string | null | undefined): string {
  return iso ? iso.slice(0, 10) : '';
}

/** `<input type="date">`-Wert (JJJJ-MM-TT) → ISO-UTC-Zeitstempel, oder undefined. */
export function dateInputToIso(value: string): string | undefined {
  return value ? `${value}T00:00:00.000Z` : undefined;
}

/**
 * Deutsche Zahleneingabe robust parsen: Komma = Dezimaltrenner, Punkte davor
 * sind Tausenderpunkte („1.500,50" → 1500.5). Ohne Komma gilt ein Punkt mit
 * genau drei Nachstellen als Tausenderpunkt („1.500" → 1500), sonst als
 * Dezimalpunkt („1.5" → 1.5). Ungültig/leer → null.
 */
export function parseDecimalInput(raw: string): number | null {
  let value = raw.trim().replace(/\s/g, '');
  if (!value) return null;
  if (value.includes(',')) {
    value = value.replace(/\./g, '').replace(',', '.');
  } else {
    const dots = (value.match(/\./g) ?? []).length;
    if (dots > 1) value = value.replace(/\./g, '');
    else if (/^\-?\d{1,3}\.\d{3}$/.test(value)) value = value.replace('.', '');
  }
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}
